import { Component, OnInit } from '@angular/core';
import { ModalService } from '@root/router/index/modal.service';

@Component({
  selector: 'host-cmp-modal-price-desc',
  templateUrl: './cmp-modal-price-desc.component.html',
  styleUrls: ['./cmp-modal-price-desc.component.scss']
})
export class CmpModalPriceDescComponent implements OnInit {

  constructor(private globalModalService: ModalService) { }

  ngOnInit() {
  }

  displayCustomerServiceModal() {
    this.globalModalService.displayCustomerServiceClient();
  }

}
